import { render, staticRenderFns } from "./editArchives.vue?vue&type=template&id=2e29ef52&scoped=true"
import script from "./editArchives.vue?vue&type=script&lang=js"
export * from "./editArchives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e29ef52",
  null
  
)

export default component.exports